import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
@Injectable({
   providedIn: 'root'
})
export class ProfessionalService {
   private _addprofessional = `${environment.api}/Professional/addProfessional`;
   private _getProfessionalData = `${environment.api}/Professional/getProfessionalData`;
   private _getProfessionalRelationData = `${environment.api}/Professional/getProfessionalRelationData`;
   private _deleteProfessionalItem = `${environment.api}/Professional/deleteProfessionalItem`;
   private _exportProfessionalCsv = `${environment.api}/Professional/exportProfessionalCsv`;
   private _checkDuplicate_professional = `${environment.api}/Professional/checkDuplicate_professional`;
   private _professionalStatusUrl = `${environment.api}/Professional/professionalActiveById`;
   private _saveImportProfessionalUrl = `${environment.api}/Professional/saveImportProfessional`;
   private _professionalListFilterUrl = `${environment.api}/Professional/professionalListFilter`;
   private _customerprofessionalListFilterUrl = `${environment.api}/Professional/customerprofessionalListFilter`;
   private _getProfessionalListUrl = `${environment.api}/Professional/getProfessionalListByid`;
   private _getCustomerProfessionalListUrl = `${environment.api}/Professional/getCustomerProfessionalList`;
   private _getCustomerProfessionalPerDataUrl = `${environment.api}/Professional/getCustomerProfessionalPerData`;

   private _updateTimeTotalUrl = `${environment.api}/Professional/updateTimeTotal`;
   //  added by archana /02/22/2023 not in use till today
   private _getProfessionalDataForXlsxUrl = `${environment.api}/Professional/getProfessionalDataForXlsx`;
   // added by archana on 24/02/2023for importing xlsx professional data add professional
   private _addProfessionalDataForXlsxUrl = `${environment.api}/Professional/addProfessionalDataForXlsx`;
   private _getCustomerProfessionalListImportUrl = `${environment.api}/Professional/getCustomerProfessionalListImport`;
   private _getAndSaveProInfoForImportUrl = `${environment.api}/Professional/getAndSaveProInfoForImport`;
   private _DeleteProInfoForImportUrl = `${environment.api}/Professional/DeleteProInfoForImport`;
   private _getCustomerProfessionalListImportEditMobileUrl = `${environment.api}/Professional/getCustomerProfessionalListImportEditMobile`;
   private _getCustomerProfessionalListEditMobileUrl = `${environment.api}/Professional/getCustomerProfessionalListEditMobile`;
   private _getCustomerProfessionalListEditMobileInactiveUrl = `${environment.api}/Professional/getCustomerProfessionalListEditMobileInactive`;

   //created by deepak on 22/march/23
   private _getMainProfessionalListForImportUrl = `${environment.api}/Professional/getMainProfessionalListForImport`;

   // added by archana on 27/march/2023
   private _getTemplateInfoForImportUrl = `${environment.api}/Professional/getTemplateInfoForImport`;

   private _saveTemplateForMappingUrl = `${environment.api}/Professional/saveTemplateForMapping`;
   private _updateTemplateForMappingUrl = `${environment.api}/Professional/updateTemplateForMapping`;
   private _exportToProfessionalCsvUrl = `${environment.api}/Professional/exportToProfessionalCsv`;
   constructor(private http: HttpClient) { }
   //professional services
   addprofessionaldata(data) {
      return this.http.post<any>(this._addprofessional, data);
   }
   getprofessionaldata(data) {
      return this.http.post<any>(this._getProfessionalData, data);
   }

   getprofessionalrelationdata(data) {
      return this.http.post<any>(this._getProfessionalRelationData, data);
   }
   deleteProfessionalItem(data) {
      return this.http.post<any>(this._deleteProfessionalItem, data);
   }

   exportProfessionalCsv(data) {
      return this.http.post<any>(this._exportProfessionalCsv, data);
   }

   checkDuplicate_professional(data) {
      return this.http.post<any>(this._checkDuplicate_professional, data);
   }
   //code by Archana 5/may/2022
   activeInactiveProfessional(data) {
      return this.http.post<any>(this._professionalStatusUrl, data);
   }
   saveImportProfessional(data) {
      return this.http.post<any>(this._saveImportProfessionalUrl, data);
   }
   professionalListFilter(data) {
      return this.http.post<any>(this._professionalListFilterUrl, data);
   }
   customerprofessionalListFilter(data) {
      return this.http.post<any>(this._customerprofessionalListFilterUrl, data);
   }

   getProfessionalList(data) {
      return this.http.post<any>(this._getProfessionalListUrl, data);
   }

   getCustomerProfessionalList(data) {
      return this.http.post<any>(this._getCustomerProfessionalListUrl, data);
   }

   getCustomerProfessionalPerData(data) {
      return this.http.post<any>(this._getCustomerProfessionalPerDataUrl, data);
   }

   updateTimeTotal(data) {
      return this.http.post<any>(this._updateTimeTotalUrl, data);
   }
   //  added by archana /02/22/2023 not in use till today
   getProfessionalDataForXlsx(data) {
      return this.http.post<any>(this._getProfessionalDataForXlsxUrl, data);
   }
   // added by archana on 24/02/2023for importing xlsx professional data add professional
   addProfessionalDataForXlsx(data) {
      return this.http.post<any>(this._addProfessionalDataForXlsxUrl, data);
   }
   getCustomerProfessionalListImport(data) {
      return this.http.post<any>(this._getCustomerProfessionalListImportUrl, data);
   }
   getAndSaveProInfoForImport(data) {
      return this.http.post<any>(this._getAndSaveProInfoForImportUrl, data);
   }
   DeleteProInfoForImport(data) {
      return this.http.post<any>(this._DeleteProInfoForImportUrl, data);
   }
   getCustomerProfessionalListImportEditMobile(data) {
      return this.http.post<any>(this._getCustomerProfessionalListImportEditMobileUrl, data);
   }
   getCustomerProfessionalListEditMobile(data) {
      return this.http.post<any>(this._getCustomerProfessionalListEditMobileUrl, data);
   }

   getMainProfessionalListForImport(data) {
      return this.http.post<any>(this._getMainProfessionalListForImportUrl, data);
   }
   // added by archana 30/03/2023
   getTemplateInfoForImport(data) {
      return this.http.post<any>(this._getTemplateInfoForImportUrl, data);
   }
   saveTemplateForMapping(data) {
      return this.http.post<any>(this._saveTemplateForMappingUrl, data);
   }
   updateTemplateForMapping(data) {
      return this.http.post<any>(this._updateTemplateForMappingUrl, data);
   }
   getCustomerProfessionalListEditMobileInactive(data) {
      return this.http.post<any>(this._getCustomerProfessionalListEditMobileInactiveUrl, data);
   }
   exportToProfessionalCsv(data) {
      return this.http.post<any>(this._exportToProfessionalCsvUrl, data);
   }
}